'use strict';
var novicell = novicell || {};

novicell.bootcamps = novicell.bootcamps || function () {

    function init() {
        bootcampSlider();
    }

    function bootcampSlider() {

        var siemaSelector = document.getElementsByClassName('bootcamps-slider');
    
        if ( siemaSelector[0] ) {

            // Init Siema slider
            const siema = new Siema ({
                selector: siemaSelector[0],
                perPage: {
                    100: 1,
                    700: 2,
                    1000: 3
                }
            });
        
            const prev = document.querySelector('.bootcamps-controls--prev');
            const next = document.querySelector('.bootcamps-controls--next');
    
            prev.addEventListener('click', () => siema.prev());
            next.addEventListener('click', () => siema.next());
        }

    }

    return {
        init : init,
        bootcampSlider : bootcampSlider
    };

}();